import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../components/chadcn/Tooltip";
import MaterialIcon from "../../components/MaterialIcon";
import cn from "../../util/cn";

export type PriorityIconWithTooltipProps = {
  arrow: "single" | "double";
  arrowDirection: "up" | "down";
  color: "text-measurement-text-emergency" | "text-measurement-text-warning";
  tooltipText: string;
};

const PriorityIconWithTooltip = ({
  arrow,
  arrowDirection,
  color,
  tooltipText,
}: PriorityIconWithTooltipProps) => {
  const iconName = arrow === "double" ? "keyboard_double_arrow_up" : "keyboard_arrow_up";

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger className="flex items-center">
          <MaterialIcon
            iconName={iconName}
            className={cn(arrowDirection === "up" ? "" : "rotate-180", color)}
          />
        </TooltipTrigger>
        <TooltipContent className="select-none text-base shadow-lg ring-1 ring-slate-200">
          <p className="whitespace-pre-wrap text-primary/90">{tooltipText}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default PriorityIconWithTooltip;
